import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, namespace, State } from 'vuex-class';
import { Logger } from 'fsts';
import { ROUTES } from '@/router/routesEnum';
import { NewsService } from '../../utils/newsHelper';
import { idMask } from '@/components/idMaskService';
import { SupportContact, ErrorMailInfo } from '@/shared/model/supportContact';
import DateUtils from '@/shared/utils/DateUtils';

const authModule = namespace('auth');
const logger = new Logger('app');
const contactModule = namespace('contact');
const admpNewsModule = namespace('admpNews');
const companyModule = namespace('company');
@Component({
  components: {},
})
export default class About extends Vue {
  @authModule.Action('getSupportContacts')
  private actionGetSupportContacts: any;
  @authModule.Getter('isUserSupportOrSuperAdmin')
  private isUserInAzureAdminGroup!: any;

  @admpNewsModule.Getter('getUnreadNews')
  private getUnreadNews: any;
  @admpNewsModule.Action('getDashboardAdmpNews')
  private actionGetDashboardAdmpNews!: any;
  @admpNewsModule.Getter('getAdmpNewsDashboard')
  private getAdmpNewsDashboard!: any;
  @admpNewsModule.Getter('getAdmpNewsImages')
  private getAdmpNewsImages!: any;
  @admpNewsModule.Action('getNewsFileDownloadLink')
  private actionGetNewsFileDownloadLink!: any;
  @admpNewsModule.Action('updateAdmpNewsImages')
  private actionUpdateAdmpNewsImages!: any;
  @admpNewsModule.Action('upsertAdmpNewsReadInfo')
  private actionUpsertAdmpNewsReadInfo!: any;
  @admpNewsModule.Getter('getAdmpNewsDashboardIsLoading')
  private admpNewsDashboardIsLoading!: boolean;
  @companyModule.Getter('getCompanyUserZrs')
  private companyUserZrs!: any;
  @companyModule.Getter('getIsLoadCompanyUserZrs')
  private isLoadCompanyUserZrs!: any;
  @authModule.Getter('isUserSupportOrSuperAdmin')
  private isUserInAzureAdminGroupGetter!: any;

  @contactModule.Getter('getContactForLoggedInUser')
  private contactForLoggedInUser!: any;

  activeTab: any = null;
  supportContactList: SupportContact[] = [];

  async created() {
    document.title = this.$i18n.tc('Home');
    await this.actionGetSupportContacts()
      .then((result: any) => {
        this.supportContactList = result;
      })
      .catch((err: any) => {
        logger.error(err);
      });
  }

  get isRealXl() {
    return this.$vuetify.breakpoint.width < 1920;
  }

  showSchulungsvideos() {
    let url: any = 'https://www.meinvme.de/vme-portal-produktbeschreibung ';
    window.open(url, '_blank');
  }

  //#region AdmpNews
  changeTabs() {
    console.log(
      '-------------------changeTabs-----------------------------------------  ===>>> this.activeTab  ',
      this.activeTab
    );
    if (this.activeTab == 'importantnotice') {
      setTimeout(() => {
        this.getDashboardNewsData();
      }, 1000);
    }
  }

  get items() {
    return this.getAdmpNewsDashboard;
  }

  private async getDashboardNewsData() {
    const payload = {
      contactRecordID: this.contactForLoggedInUser?.recordID,
      isUserInAzureAdminGroup: this.isUserInAzureAdminGroup,
    };
    await this.actionGetDashboardAdmpNews(payload)
      .then((result: any) => {
        this.items.forEach((item: any) => {
          this.downloadImage(item);
        });
      })
      .catch((err: any) => {
        logger.error(err);
      });
  }

  markAsFavorite(item: any, value: any) {
    NewsService.markAsFavorite(item, value, this.actionUpsertAdmpNewsReadInfo);
  }

  changeReadStatus(item: any, readStatus: boolean) {
    console.log('item :>> ', item);
    NewsService.changeReadStatus(item, readStatus, this.actionUpsertAdmpNewsReadInfo);
  }

  async downloadImage(item: any) {
    const isAlreadyLoaded = !!this.getAdmpNewsImages[item.id];

    await NewsService.downloadImageForTile(
      item,
      isAlreadyLoaded,
      this.actionGetNewsFileDownloadLink,
      this.actionUpdateAdmpNewsImages
    );
  }

  getNoDataText() {
    return '';
  }

  get dynamicNewsIteratorHeight() {
    if (this.$vuetify.breakpoint.xlOnly && this.$vuetify.breakpoint.width > 1980) {
      return 380;
    }
    if (this.$vuetify.breakpoint.xlOnly && this.$vuetify.breakpoint.width <= 1980) {
      return 430;
    } else if (
      this.$vuetify.breakpoint.lgOnly &&
      this.$vuetify.breakpoint.width > 1580 &&
      this.$vuetify.breakpoint.width <= 1920
    ) {
      return 430;
    } else if (this.$vuetify.breakpoint.lgOnly && this.$vuetify.breakpoint.width < 1580) {
      return 430;
    } else if (this.$vuetify.breakpoint.mdOnly) {
      return 430;
    } else if (this.$vuetify.breakpoint.smOnly && this.$vuetify.breakpoint.width < 965) {
      return 430;
    }

    return 380;
  }

  private openAdmpNews(item: any) {
    logger.log('openAdmpNews item :>> ', item);
    const hashId = idMask.encode(item.id);

    this.$router.push({
      name: ROUTES.newsaddedit,
      params: { admpNewsId: hashId },
    });
  }

   formatIsoToDot(value: string) {
      let result = DateUtils.isoDateTimeStringToDotsDate(value);
      return result;
    }
  //#endregion AdmpNews
}
